import BarCity from "@/components/Map/BarCity";

export default function Map() {
  return (
    <div>
      <BarCity /> {/* 바 도시 컴포넌트 */}
    </div>
  );
}
